export const RESOURCE_BASE = 'resource/RESOURCE_BASE'
export const RESOURCE_LOADING = 'resource/RESOURCE_LOADING'
export const RESOURCE_SUCCESS = 'resource/RESOURCE_SUCCESS'